import { isHavingProps } from '../helpers/object'

export const getAddress = (addressComponents, formattedAddress = "", coords = {}, ADRformatted = "") => {
  const address = {
    building: '',
    street: '',
    city: '',
    state: '',
    postcode: '',
    administrativeAreaLevel3: '',
    formattedAddress,
    coords,
  }
  for (const component of addressComponents) {
    const { types, short_name: shortName, long_name: name } = component
    if (types.length && name) {
      for (const type of types) {
        switch (type) {
          case 'route':
            address.street = name
            break
          case 'postal_code':
            address.postcode = name
            break
          case 'street_number':
            address.building = name
            break
          case 'administrative_area_level_1':
            address.state = name
            address.stateAbbr = shortName
            break
          case 'locality':
            address.city = name
            break
          case 'administrative_area_level_3':
            address.administrativeAreaLevel3 = name
            break
          case 'neighborhood':
            address.neighborhood = name
            break
        }
      }
      const {
        city = '',
        administrativeAreaLevel3 = '',
        neighborhood = '',
      } = address
      if (!city)
        if (administrativeAreaLevel3) {
          address.city = administrativeAreaLevel3
        } else if (neighborhood) {
          address.city = neighborhood
        }

      // sometimes locality in components wrong but in ADR formatted string always(?) correct
      if (ADRformatted) {
        const cityFromAdr = ADRformatted.match(/<span class="locality">(.*?)<\/span>/)
        if (cityFromAdr?.length > 1) address.city = cityFromAdr[1]
      }
    }
  }
  delete address.administrativeAreaLevel3

  return address
}

export const getFormattedAddress = (data = {}) => {
  if (!data || !data.street || !data.city || !data.state || !data.postcode) return ''

  return `${
    data.building ? data.building : ''
  } ${
    data.street ? data.street + ', ' : ''
  }${
    data.city ? data.city + ', ' : ''
  }${
    data.state ? data.state + ', ' : ''
  }${
    data.postcode ? data.postcode : ''
  }`
}

export const checkAddressIsFulfilled = (address = {}) => {
  return !(
    !address?.postcode ||
    !address?.state ||
    !address?.city ||
    !address?.street ||
    !address?.building
  )
}

export const getAddressInputErrorText = (address = {}, isRequired = true) => {
  if (isRequired && !isHavingProps(address)) {
    return 'This field is required'
  } else if (!address?.postcode) return 'Postcode is required'
  else if (!address?.state) return 'State is required'
  else if (!address?.city) return 'City is required'
  else if (!address?.street) return 'Street is required'
  else if (!address?.building) return 'Building is required'
  else return ''
}

export const checkAddressesEqual = (address1 = {}, address2 = {}) => {
  if (!isHavingProps(address1) || !isHavingProps(address2)) return false
  return (
    address1?.postcode === address2?.postcode &&
    address1?.state === address2?.state &&
    address1?.city === address2?.city &&
    address1?.street === address2?.street &&
    address1?.building === address2?.building
  )
}
